import { Button } from '@mui/material';

interface ButtonComponentProps {
  onClick: () => void;
  label: string;
  errors?: any;
  disabled?: boolean;
  currentRecord?: any;
  keyName?: string;
  loading?: boolean;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
}
const ButtonComponent: React.FC<ButtonComponentProps> = ({
  onClick,
  label,
  keyName,
  color,
  loading,
  disabled,
}) => {
  return (
    <Button
      sx={{
        color: color ? 'secondary' : '#fff',
        cursor: loading ? 'not-allowed' : 'pointer',
      }}
      type="button"
      id={keyName}
      key={keyName}
      disabled={disabled}
      variant="contained"
      color={color ? color : 'primary'}
      onClick={() => {
        onClick();
      }}
    >
      {label}
    </Button>
  );
};
export default ButtonComponent;
